var exports = {
  "tb": "UserProfileModal.module__noteTextarea___cnczV0",
  "CR": "UserProfileModal.module__modalRoot___cnczV0",
  "eF": "UserProfileModal.module__userInfo___cnczV0",
  "hR": "UserProfileModal.module__userInfoHeader___cnczV0",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___cnczV0",
  "Rn": "UserProfileModal.module__userInfoContent___cnczV0",
  "yn": "UserProfileModal.module__profileDataWarning___cnczV0",
  "S7": "UserProfileModal.module__nameRow___cnczV0",
  "nT": "UserProfileModal.module__userName___cnczV0",
  "a1": "UserProfileModal.module__userTag___cnczV0",
  "Fj": "UserProfileModal.module__usernameRow___cnczV0",
  "hI": "UserProfileModal.module__pronouns___cnczV0",
  "sM": "UserProfileModal.module__srOnly___cnczV0",
  "Li": "UserProfileModal.module__customStatusText___cnczV0",
  "Ef": "UserProfileModal.module__customStatusRow___cnczV0",
  "_z": "UserProfileModal.module__tagBadgeRow___cnczV0",
  "U3": "UserProfileModal.module__badgesWrapper___cnczV0",
  "ZV": "UserProfileModal.module__userNoteEditor___cnczV0",
  "xu": "UserProfileModal.module__noteLabel___cnczV0",
  "_j": "UserProfileModal.module__noteTextareaBase___cnczV0",
  "jd": "UserProfileModal.module__noteTextareaEditing___cnczV0",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___cnczV0",
  "bs": "UserProfileModal.module__profileContent___cnczV0",
  "EM": "UserProfileModal.module__profileContentHeader___cnczV0",
  "cI": "UserProfileModal.module__bannerContainer___cnczV0",
  "HG": "UserProfileModal.module__bannerMask___cnczV0",
  "_e": "UserProfileModal.module__bannerImage___cnczV0",
  "N1": "UserProfileModal.module__headerContainer___cnczV0",
  "H": "UserProfileModal.module__avatarContainer___cnczV0",
  "fc": "UserProfileModal.module__actionButtonsContainer___cnczV0",
  "hQ": "UserProfileModal.module__contentContainer___cnczV0",
  "sq": "UserProfileModal.module__profileContentWrapper___cnczV0",
  "zL": "UserProfileModal.module__scrollerFullHeight___cnczV0",
  "jT": "UserProfileModal.module__modalContainer___cnczV0",
  "uu": "UserProfileModal.module__actionButtons___cnczV0",
  "iA": "UserProfileModal.module__buttonIcon___cnczV0",
  "ro": "UserProfileModal.module__menuIcon___cnczV0",
  "WB": "UserProfileModal.module__avatarFocusRing___cnczV0",
  "VS": "UserProfileModal.module__tabsWrapper___cnczV0",
  "OT": "UserProfileModal.module__mutualFriendsList___cnczV0",
  "Z8": "UserProfileModal.module__mutualSectionDivider___cnczV0",
  "KF": "UserProfileModal.module__mutualFriendItem___cnczV0",
  "vu": "UserProfileModal.module__active___cnczV0",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___cnczV0",
  "D9": "UserProfileModal.module__mutualFriendInfo___cnczV0",
  "eV": "UserProfileModal.module__mutualFriendName___cnczV0",
  "zD": "UserProfileModal.module__mutualFriendUsername___cnczV0",
  "p$": "UserProfileModal.module__emptyState___cnczV0",
  "Ny": "UserProfileModal.module__mutualGuildIcon___cnczV0",
  "me": "UserProfileModal.module__separator___cnczV0",
  "AI": "UserProfileModal.module__emptyStateIcon___cnczV0",
};

module.exports = exports;
